import { render, staticRenderFns } from "./instructionsDetailShopItem.vue?vue&type=template&id=1f54e74a&scoped=true&"
import script from "./instructionsDetailShopItem.vue?vue&type=script&lang=js&"
export * from "./instructionsDetailShopItem.vue?vue&type=script&lang=js&"
import style0 from "./instructionsDetailShopItem.vue?vue&type=style&index=0&id=1f54e74a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f54e74a",
  null
  
)

export default component.exports